import React from 'react';

export default class Page10 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToDevelopOthers');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <div className="border_subtitle">Gather information</div>
                                            <p>Gather information to help you develop people more effectively.
                                                This might include information
                                                about the role requirements of the people you manage, the extent
                                                to which they’re meeting them,
                                                future business requirements, up and coming development
                                                opportunities and a budget,
                                                if appropriate.</p>


                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">Further Information</span>
                                            </div>
                                            <div className="paraspace"><p>If you found this tool useful, then
                                                you are likely to find the following tools both insightful and
                                                relevant:</p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToMaintainMomentum')}>How
                                                        to maintain momentum</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToMotivateOthers')}>How
                                                        to motivate others</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToInfluenceOthers')}>How
                                                        to influence others</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToManageDifficultConversations')}>How
                                                        to manage difficult conversations</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToCreateTeamIdentity')}>How
                                                        to create team identity</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToGainBuyInAndCommitment')}>How
                                                        to gain buy-in and commitment</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToSupportAndChallengeInTandem')}>How
                                                        to support and challenge in tandem</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToIdentifyPersonalLearningStyles')}>How
                                                        to identify personal learning styles</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToFormulateActionPlans')}>How
                                                        to formulate action plans</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToDelegate')}>How
                                                        to delegate.</div></li>


                                                </ul>
                                            </div>
                                            <div className="circle_title "><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ol className="testclass">

                                                <li><p className="further_info_content"> Ross, L., Lepper,
                                                    M. &amp; Hubbard, M. (1975). Perseverance in self-perception
                                                    and social perception:
                                                    Biased attributional processes in the debriefing
                                                    paradigm,<span className="subtiltereg">  Journal of Personality and Social Psychology,
32, 880-892.</span></p></li>
                                                <li><p className="further_info_content">Ribes,
                                                    E., &amp; Rodriguez, M. E. (2011). Correspondence between
                                                    instructions, performance, and selfdescriptions
                                                    in a conditional discrimination task: The effects of
                                                    feedback and type of matching response.<span
                                                        className="subtiltereg">
The Psychological Record,</span> 51(2), 9.</p></li>
                                                <li><p className="further_info_content">Liz Simpson (2001).
                                                    Divorcing the Boss,<span className="subtiltereg">  Personnel Today Magazine.</span>
                                                </p></li>
                                                <li><p className="further_info_content">Honey, P. and Mumford,
                                                    A. (1986).<span className="subtiltereg">  A Manual of Learning Styles Peter Honey, Maidenhead.</span>
                                                </p></li>
                                                <li><p className="further_info_content">Harrold, F. (2002).<span
                                                    className="subtiltereg">  The 10 minute life coach Hodder and Stoughton.</span>
                                                </p></li>


                                            </ol>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page9')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('People')}
                                                    className="button-next-previous-done">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}